export class User {
    id : String;
}